module.exports = __webpack_public_path__ + "static/candy.2414262e.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/candy.png
// module id = 569
// module chunks = 263791100135453